export default __webpack_public_path__ + "static/media/renewal-available_loan.d4d52ddf.jpg";